export function isUniquePerGroupDescriptor(descriptor) {
    return descriptor.uniquePerGroup === true;
}
export function createNextRowContext(group, groupIndex) {
    return {
        group,
        groupIndex,
        row: {
            parameter: null,
            comparator: null,
            value: null
        },
        rowIndex: group.rows.length
    };
}
export function canAddRowForGroup(descriptors, context) {
    const enabledDescriptors = descriptors.filter((descriptor) => !descriptor.disabled);
    if (enabledDescriptors.length === 0) {
        return false;
    }
    if (enabledDescriptors.some((descriptor) => !isUniquePerGroupDescriptor(descriptor))) {
        return true;
    }
    const usedParameterKeys = getUsedUniqueParameterKeys(enabledDescriptors, context);
    return enabledDescriptors.some((descriptor) => !usedParameterKeys.has(descriptor.key));
}
function getUsedUniqueParameterKeys(descriptors, context) {
    const uniqueDescriptorKeys = new Set(descriptors
        .filter(isUniquePerGroupDescriptor)
        .map((descriptor) => descriptor.key));
    return new Set(context.group.rows
        .filter((groupRow, rowIndex) => rowIndex !== context.rowIndex &&
        groupRow.parameter !== null &&
        uniqueDescriptorKeys.has(groupRow.parameter))
        .map((groupRow) => groupRow.parameter));
}
export function filterAvailableParametersForGroup(descriptors, context) {
    const usedParameterKeys = getUsedUniqueParameterKeys(descriptors, context);
    return descriptors.filter((descriptor) => descriptor.key === context.row.parameter ||
        !isUniquePerGroupDescriptor(descriptor) ||
        !usedParameterKeys.has(descriptor.key));
}
export function compoundValues(editor) {
    if (editor?.type !== 'COMPOUND') {
        return {};
    }
    return Object.fromEntries(editor.fields.map((field) => [
        field.key,
        field.type === 'MULTIPLE_ENTITY' ? [] : null
    ]));
}
export function selectOptions(options, selectedKeys) {
    return options.filter((option) => !option.disabled || selectedKeys.includes(option.key));
}
export function findOption(options, key) {
    return key === null
        ? null
        : (options.find((option) => option.key === key) ?? null);
}
export function resolveEditor(descriptor, comparator) {
    if (!descriptor) {
        return null;
    }
    return typeof descriptor.valueEditor === 'function'
        ? descriptor.valueEditor(comparator)
        : descriptor.valueEditor;
}
export function expectedValueType(editor, comparator) {
    if (editor?.type !== 'VALUE') {
        return editor?.type ?? null;
    }
    return comparator === 'BETWEEN' ? 'RANGE' : 'VALUE';
}
export function emptyValue(editor, comparator) {
    switch (expectedValueType(editor, comparator)) {
        case 'ENTITY':
            return { type: 'ENTITY', key: null };
        case 'MULTIPLE_ENTITY':
            return { type: 'MULTIPLE_ENTITY', keys: [] };
        case 'VALUE':
            return { type: 'VALUE', value: null };
        case 'RANGE':
            return { type: 'RANGE', from: null, to: null };
        case 'COMPOUND':
            return { type: 'COMPOUND', values: compoundValues(editor) };
        default:
            return null;
    }
}
export function numberToInput(value) {
    return value === null ? '' : String(value);
}
export function inputToNumber(value) {
    if (value.trim() === '') {
        return null;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
}
